import { ExcelTemplate } from "../../interfaces";
import * as XLSX from 'xlsx-js-style';
import { setColumnWidth, withHeaderStyling } from "../../utils";
import { getPreparedData } from "./mapping";
import { fitToColumn } from "../financial-statement/utils";
import {
  CompanyComparableValuationExcelExportData,
} from '../../../company-performance/companies-stocks/dto/StockAuxiliary';

export class ComparableCompanyValuation implements ExcelTemplate {
  export(data: CompanyComparableValuationExcelExportData): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  getSheet(data: CompanyComparableValuationExcelExportData): XLSX.WorkSheet {
    const preparedData = getPreparedData(data);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const largeColumn = [6];
    const nameColumn = [0, 1];
    largeColumn.forEach((index) => setColumnWidth(sheet, index, 50));
    nameColumn.forEach((index) => setColumnWidth(sheet, index, 20));
    return withHeaderStyling(sheet);
  }

}
